<template>
  <div class="hovered-button" @mouseleave="onLeave" @mousemove="trackPointer" @mouseover="onHover">
    <div class="hover-header" :class="{ 'hover-header-disabled': checkboxData.disabled }">
      <div class="hover-title">
        <span v-if="checkboxData.types && !checkboxData.types.length">➥ </span>
        {{ checkboxData.title }}
      </div>
      <div class="row-checkbox">
        <span class="checkbox-container">
          <CheckboxGeneralDropdown
            :id="checkboxData.id"
            :class="{ 'disabled-checkbox': checkboxData.disabled }"
            :checked="checkboxData.visible"
            @toggle="onToggle"
          />
        </span>
      </div>
    </div>
    <TooltipGeneral
      v-if="showHoverExplanationText"
      :title="
        checkboxData.disabledHoverExplanationText ? checkboxData.disabledHoverExplanationText : ''
      "
      :pointerEvent="trackPointerEvent"
    />
  </div>
</template>
<script setup lang="ts">
import CheckboxGeneralDropdown from '../selectors/DropdownDashboard/Checkbox/CheckboxGeneralDropdown.vue'
import TooltipGeneral from '../TooltipGeneral.vue'
import { ref } from 'vue'

const props = defineProps<{
  checkboxData: {
    id: string
    title: string
    visible: boolean
    disabled?: boolean
    disabledHoverExplanationText?: string
    types?: string[]
  }
}>()
const emits = defineEmits<{
  (e: 'toggle', id: string): void
}>()

const showHoverExplanationText = ref(false)
const trackPointerEvent = ref<MouseEvent | null>(null)
function onHover(event: MouseEvent) {
  if (!props.checkboxData.disabled) return
  const targetEl = event.target as HTMLElement
  if (targetEl.offsetWidth < targetEl.scrollWidth) showHoverExplanationText.value = true
}
function onLeave() {
  showHoverExplanationText.value = false
  trackPointerEvent.value = null
}
function onToggle(id: string) {
  emits('toggle', id)
}
function trackPointer(event: MouseEvent) {
  if (!props.checkboxData.disabled) return
  trackPointerEvent.value = event
}
</script>
<style lang="scss" scoped>
@use '@/styles/variables.scss';

.checkbox-container {
  width: 12px;
  height: 12px;
}
.disabled-checkbox {
  cursor: not-allowed;
  background-color: variables.$color-grey-light;
  color: variables.$color-grey-dark;
}
.hovered-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  width: 60px;
}
.hover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: variables.$box-shadow-overview-button;
  border-radius: 4px;
  padding: 4px;
  font-size: 11px;
  text-align: left;
  overflow: visible;
  background-color: variables.$color-grey-lighter;
  color: variables.$color-text-grey;
  min-width: 130px;
  &-disabled {
    cursor: not-allowed;
    background: variables.$color-grey;
    color: variables.$color-text-white-70;
    &:hover {
      background: variables.$color-grey;
      color: variables.$color-text-white-70;
    }
  }

  .hover-title {
    margin-left: 6px;
    max-width: 90px;
    word-break: break-word;
  }
}

.row-checkbox {
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    align-items: center;
    margin-right: 8px;
  }
}
</style>
